module.exports = __webpack_public_path__ + "static/img/type1.ed97256c.jpg";